import type { SVGProps } from "react";
const SvgNumber06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="40.151pt"
    height="72.479pt"
    viewBox="36.191 -103.644 40.151 72.479"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 74.008,60.578 C 74.054,59.745 74.097,58.201 74.137,55.947 L 74.164,50.624 C 74.092,45.321 72.391,40.981 69.061,37.603 C 65.732,34.225 61.244,32.162 55.597,31.415 C 50.268,30.71 45.951,31.495 42.648,33.769 C 39.345,36.044 37.444,39.795 36.946,45.022 C 36.761,46.418 36.659,47.922 36.639,49.533 L 36.198,80.656 C 36.071,85.998 37.706,90.475 41.101,94.087 C 44.496,97.7 49.017,99.879 54.664,100.627 C 59.549,101.273 63.659,100.461 66.994,98.191 C 70.329,95.921 72.295,92.533 72.891,88.029 C 72.958,87.521 73.004,86.688 73.028,85.529 L 73.019,81.945 C 72.997,81.619 72.89,81.331 72.698,81.079 C 72.505,80.828 72.25,80.681 71.933,80.639 L 58.799,78.901 C 58.482,78.859 58.214,78.937 57.994,79.134 C 57.774,79.331 57.675,79.592 57.696,79.917 L 57.654,82.43 L 57.623,83.394 C 57.497,84.346 57.152,85.123 56.588,85.726 C 56.024,86.33 55.425,86.589 54.791,86.505 C 53.839,86.379 53.067,85.874 52.474,84.988 C 51.881,84.103 51.577,82.981 51.563,81.624 L 51.656,72.146 C 51.707,71.765 51.906,71.727 52.253,72.031 C 54.42,74.19 56.773,75.438 59.31,75.773 C 63.308,76.302 66.569,75.443 69.094,73.194 C 71.619,70.946 73.175,67.601 73.763,63.16 C 73.914,62.018 73.996,61.157 74.008,60.578 Z M 58.569,55.049 L 58.376,60.156 C 58.289,61.306 57.945,62.197 57.345,62.828 C 56.745,63.459 56.032,63.719 55.208,63.61 C 54.256,63.484 53.493,63.028 52.919,62.242 C 52.346,61.456 52.012,60.444 51.917,59.205 L 51.811,54.155 L 51.946,48.75 C 52.051,47.473 52.403,46.519 53.003,45.888 C 53.603,45.257 54.379,45.005 55.331,45.131 C 56.282,45.257 57.027,45.726 57.565,46.54 C 58.103,47.354 58.414,48.412 58.5,49.714 L 58.569,55.049 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 76.186,63.38 C 76.232,62.547 76.275,61.003 76.315,58.749 L 76.342,53.426 C 76.27,48.123 74.569,43.783 71.239,40.405 C 67.91,37.027 63.422,34.964 57.775,34.217 C 52.446,33.512 48.129,34.297 44.826,36.571 C 41.523,38.846 39.622,42.597 39.124,47.824 C 38.939,49.22 38.837,50.724 38.817,52.335 L 38.376,83.458 C 38.249,88.8 39.884,93.277 43.279,96.889 C 46.674,100.502 51.195,102.681 56.842,103.429 C 61.727,104.075 65.837,103.263 69.172,100.993 C 72.507,98.723 74.473,95.335 75.069,90.831 C 75.136,90.323 75.182,89.49 75.206,88.331 L 75.197,84.747 C 75.175,84.421 75.068,84.133 74.876,83.881 C 74.683,83.63 74.428,83.483 74.111,83.441 L 60.977,81.703 C 60.66,81.661 60.392,81.739 60.172,81.936 C 59.952,82.133 59.853,82.394 59.874,82.719 L 59.832,85.232 L 59.801,86.196 C 59.675,87.148 59.33,87.925 58.766,88.528 C 58.202,89.131 57.603,89.391 56.969,89.307 C 56.017,89.181 55.245,88.676 54.652,87.79 C 54.059,86.905 53.755,85.783 53.741,84.426 L 53.834,74.948 C 53.885,74.567 54.084,74.529 54.431,74.833 C 56.598,76.992 58.951,78.24 61.488,78.575 C 65.486,79.104 68.747,78.245 71.272,75.996 C 73.797,73.748 75.353,70.403 75.941,65.962 C 76.092,64.82 76.174,63.959 76.186,63.38 Z M 60.747,57.851 L 60.554,62.958 C 60.467,64.108 60.123,64.999 59.523,65.63 C 58.923,66.261 58.21,66.521 57.386,66.412 C 56.434,66.286 55.671,65.83 55.097,65.044 C 54.524,64.258 54.19,63.246 54.095,62.007 L 53.989,56.957 L 54.124,51.552 C 54.229,50.275 54.581,49.321 55.181,48.69 C 55.781,48.059 56.557,47.807 57.508,47.933 C 58.46,48.059 59.205,48.528 59.743,49.342 C 60.281,50.156 60.592,51.214 60.678,52.516 L 60.747,57.851 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber06;
